import AudioIcon from 'assets/icons/pathway/AudioIcon';
import { BodyLarge, FlexSmAlignCenter } from 'components/Elements';
import { GenerateType } from 'models/Activity';
import { theme } from 'theme';
import strings from '../../../../strings/strings.json';

export function GenerateTypeContentComponent({ generateType }: GenerateTypeContentComponentProps): JSX.Element {
    switch (generateType) {
        case GenerateType.TEXT_TO_AUDIO:
            return (
                <FlexSmAlignCenter>
                    <AudioIcon colour={theme.textColour} />
                    <BodyLarge $bold>{strings.courseAIGeneratedContentComponent.generateTypeTitle}</BodyLarge>
                </FlexSmAlignCenter>
            );
        default:
            return <></>;
    }
}

type GenerateTypeContentComponentProps = {
    generateType: GenerateType;
};
